import { i18n } from '@base/web'
import de from './de.json'
import en from './en.json'


i18n.addResourceBundle("de", "common", de, true, true)
i18n.addResourceBundle("en", "common", en, true, true)
